<template>

  <fin-side-navigation :routes="routes"
                       v-if="$vuetify.breakpoint.smAndUp"/>

  <fin-side-navigation-mobile ref="sideNav"
                              :hasContextHelp="hasContextHelp"
                              :showPopup="showPopup"
                              :routes="routes"
                              @closePopup="()=>$emit('closePopup')"
                              v-else/>

</template>

<script>
import FinSideNavigation from '@/components/navigation/sideNavigation/SideNavigation'
import FinSideNavigationMobile from '@/components/navigation/sideNavigation/sideNavigationMobile/SideNavigationMobile'
import finBrowser from "@/js/finBrowser"

export default {
  name: 'fin-side-navigation-wrapper',
  components: {
    FinSideNavigationMobile,
    FinSideNavigation
  },
  props: {
    hasContextHelp: Boolean,
    showPopup: Boolean
  },
  data() {
    const routesMobile = [
      {
        to: {name: 'myFinHub'},
        name: 'Dashboard',
        id: 'main-menuitem-finHub',
        icon: 'icon-dashboard',
        event: 'fincraft_sidemenu_finhub',
        placement: 'sidemenu',
        step: 'sidemenu_myhub'
      },
      {
        to: {name: 'finStrategy'},
        name: 'Strategy',
        id: 'main-menuitem-finStrategy',
        icon: 'icon-strategy',
        event: 'fincraft_sidemenu_strategy',
        placement: 'sidemenu',
        step: 'sidemenu_strategy'
      },
      ...process.env.VUE_APP_HIDE_NEWS_ALL === 'false' ? [
        {
          to: {name: 'news'},
          name: 'News',
          id: 'main-menuitem-finNews',
          icon: 'icon-news',
          event: 'fincraft_sidemenu_news',
          placement: 'sidemenu',
          step: 'sidemenu_news'
        }
      ] : [],
      {
        to: {name: 'finTools'},
        name: 'Tools',
        id: 'main-menuitem-finTools',
        icon: 'icon-tools',
        event: 'fincraft_sidemenu_tools',
        placement: 'sidemenu',
        step: 'sidemenu_tools'
      },
      {
        to: {name: 'finAcademy'},
        name: 'Academy',
        id: 'main-menuitem-finAcademy',
        icon: 'icon-academy',
        event: 'fincraft_sidemenu_academy',
        placement: 'sidemenu',
        step: 'sidemenu_academy'
      }
    ]

    if (process.env.VUE_APP_HIDE_COMING_FEATURES === 'false') {
      routesMobile.push({
        to: {name: 'comingFeatures'},
        name: 'Brokerage',
        id: 'main-menuitem-comingFeatures',
        icon: 'icon-finbroker',
        event: 'fincraft_sidemenu_comingFeatures',
        placement: 'sidemenu',
        step: 'sidemenu_comingFeatures'
      })
    }

    if (!finBrowser.IS_IOS_OR_ANDROID_APP) {
      // FINDEV-3272
      routesMobile.push({
        to: {name: 'community'},
        name: 'Community',
        id: 'main-menuitem-finCommunity',
        icon: 'icon-community',
        disabled: process.env.VUE_APP_DISABLE_COMMUNITY === 'true',
        event: 'fincraft_sidemenu_community',
        placement: 'sidemenu',
        step: 'sidemenu_community'
      })
    }

    const routesAdminMobile = [
      {to: {name: 'finAdminHub'}, name: 'Dashboard', icon: 'mdi-view-dashboard-variant'},
      {to: {name: 'finMaintenanceAdmin'}, name: 'Maintenance', icon: 'icon-tools'}
    ]

    if (process.env.VUE_APP_SHOW_ADMIN_SPEAKER === 'true') {
      routesAdminMobile.push({to: {name: 'finSpeakerData'}, name: 'Speaker', icon: 'icon-notification'})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_PROFILE === 'true') {
      routesAdminMobile.push({to: {name: 'myProfile'}, name: 'Profile', icon: 'icon-myfinhub'})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_USER === 'true') {
      routesAdminMobile.push({to: {name: 'finUserData'}, name: 'Users', icon: 'icon-followers'})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_SPLIT === 'true') {
      routesAdminMobile.push({to: {name: 'finSplitsData'}, name: 'Splits', icon: 'icon-chart'})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_SOCIAL === 'true') {
      routesAdminMobile.push({to: {name: 'finSocialData'}, name: 'Social', icon: 'icon-community', disabled: true})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_LEXICON === 'true') {
      routesAdminMobile.push({to: {name: 'finLexiconData'}, name: 'Lexikon', icon: 'icon-lexicon', disabled: true})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_SALES === 'true') {
      routesAdminMobile.push({to: {name: 'finSalesData'}, name: 'Sales', icon: 'icon-strategy'})
    }

    if (process.env.VUE_APP_SHOW_ADMIN_NEWSLETTER === 'true') {
      routesAdminMobile.push({to: {name: 'finNewsData'}, name: 'Newsletter', icon: 'icon-news'})
    }
    return {
      routesMobile,
      routes: [...routesMobile]
    }
  },
  methods: {
    toggle() {
      this.$refs.sideNav.toggle()
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
